import React from "react";

import * as Styled from "./loader.styled";

export const Loader = () => {
  return (
    <Styled.LoaderWrapper>
      <Styled.Loader></Styled.Loader>
    </Styled.LoaderWrapper>
  );
};
